import { getActiveTheme, setTheme } from '@cpangular/ng-material-theme';
import { AppEnvironment } from 'config-data';

export function initializeTheme(env: AppEnvironment) {
  if (getActiveTheme() !== env.defaultTheme) {
    setTheme(env.defaultTheme ?? undefined);
  }
}
